export const colors = {
  blue: '#3eb0ef',
  green: '#a4d037',
  purple: '#ad26b4',
  yellow: '#fecd35',
  red: '#f05230',
  darkgrey: '#15171A',
  midgrey: '#95b2bf',
  lightgrey: '#c5d2d9',
  whitegrey: '#e5eff5',
  pink: '#fa3a57',
  brown: '#a3821a',
  // darkmode: color(var(--darkgrey) l(+2%)),
  darkmode: '#191b1f',

  //h
  darkmode_h: '#f4f8fb',
  light_h: '#2b2f36',

  //
  darkmode_card: '#1a1c20',
  
  //kaereba
  darkmode_kaereba: '#2b2f36',
  light_kaereba: '#f4f8fb',

  //link
  link: '#26a6ed',

};
